import { uploadEntityAttachments, deleteAttachment } from '@/lib/entity-attachments';
import type { GenericAttachment } from '@/styles/GenericAttachmentsSection';

/**
 * Shared upload path for invoice payment attachments, used by both
 * InvoicePaymentForm.tsx's edit-mode immediate upload and PaymentsTable.tsx's
 * create-mode upload-after-the-payment-exists step: the shared
 * implementation in lib/entity-attachments.ts, naming only the entity type.
 */
export function uploadInvoicePaymentAttachments(
  paymentId: string | undefined,
  files: File[],
  companyId: string,
  userId: string
): Promise<GenericAttachment[]> {
  return uploadEntityAttachments('invoice_payment', paymentId, files, companyId, userId);
}

/** Single-attachment delete from the UI (the cascade on payment delete is the server's). */
export function deleteInvoicePaymentAttachment(
  attachmentId: string,
  userId: string | undefined
): Promise<boolean> {
  return deleteAttachment(attachmentId, userId);
}
